import { createSlice } from "@reduxjs/toolkit"
import adminApiService from "services/admin/departmentApiSlice"
import * as _ from "lodash"

const initialState = {
  departments: {
    departmentList: [],
    departmentMap: { ids: [], departmentMap: {} },
  },
}

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      adminApiService.endpoints.fetchDepartmentsAdmin.matchFulfilled,
      (state, action) => {
        state.departments.departmentList = action.payload
        action.payload?.forEach((department) => {
          state.departments.departmentMap.ids.push(department?._id)
          state.departments.departmentMap.departmentMap[department?._id] =
            department
        })
      }
    )
    builder.addMatcher(
      adminApiService.endpoints.fetchDepartmentsAdmin.matchRejected,
      (state, action) => {
        state.departments.departmentList = []
        state.departments.departmentMap.ids = []
        state.departments.departmentMap.departmentMap = {}
      }
    )

    builder.addMatcher(
      adminApiService.endpoints.subscribeSlug.matchFulfilled,
      (state, action) => {
        const {
          id,
          data: { source, slug },
        } = action.meta.arg.originalArgs
        const index = state.departments.departmentList.findIndex(
          (department) => department?._id === id
        )
        const sourceSubscription = {
          ...state.departments.departmentList[index]?.sourceSubscription,
          [source]: {
            source,
            slug,
            subscribed: true,
          },
        }

        //changing in list
        state.departments.departmentList[index].sourceSubscription =
          sourceSubscription

        //changing in obj
        state.departments.departmentMap.departmentMap[id] = {
          ...state.departments.departmentMap.departmentMap[id],
          sourceSubscription,
        }
      }
    )
    builder.addMatcher(
      adminApiService.endpoints.deleteSlug.matchFulfilled,
      (state, action) => {
        const { id, source } = action.meta.arg.originalArgs
        const index = state.departments.departmentList.findIndex(
          (department) => department?._id === id
        )
        const sourceSubscription = {
          ...state.departments.departmentList[index]?.sourceSubscription,
          [source]: {
            slug: "",
            subscribed: false,
          },
        }

        //changing in list
        state.departments.departmentList[index].sourceSubscription =
          sourceSubscription

        //changing in obj
        state.departments.departmentMap.departmentMap[id] = {
          ...state.departments.departmentMap.departmentMap[id],
          sourceSubscription,
        }
      }
    )
    builder.addMatcher(
      adminApiService.endpoints.updateDepartment.matchFulfilled,
      (state, action) => {
        const dep = action.meta.arg.originalArgs
        const _id = dep?._id
        const index = state.departments.departmentList.findIndex(
          (department) => department?._id == _id
        )
        state.departments.departmentList[index] = dep
        state.departments.departmentMap[_id] = dep
      }
    )
    builder.addMatcher(
      adminApiService.endpoints.patchDepartment.matchFulfilled,
      (state, action) => {
        const { id } = action.meta.arg.originalArgs
        const index = state.departments.departmentList.findIndex(
          (department) => department?._id === id
        )
        state.departments.departmentList[index] = {
          ...state.departments.departmentList[index],
          ...action.payload,
        }
        state.departments.departmentMap.departmentMap[id] = {
          ...state.departments.departmentMap.departmentMap[id],
          ...action.payload,
        }
      }
    )
  },
})

export default adminSlice.reducer
export const {} = adminSlice.actions
